export default {
  apiUrl: '/api/curations',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'curation-editor',
  customActionComponentName: 'curation-action',
  onEachSide: 1,
  preloadList: [
    {
      name: 'wines',
      target: 'getWineList',
    },
  ],
  sortOrder: [{
    field: 'order_index',
    sortField: 'order_index',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '옵션',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<i style="white-space: nowrap">아이디</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'is_enabled',
      title: '<p style="white-space: nowrap">발행</p>',
      titleClass: 'text-center',
      sortField: 'is_enabled',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    // {
    //   name: 'order_index',
    //   title: '<i style="white-space: nowrap">순서</i>',
    //   titleClass: 'text-center',
    //   dataClass: 'text-right',
    // },
    {
      name: 'title',
      title: '<i style="white-space: nowrap">제목</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    // {
    //   name: 'dsc',
    //   title: '<i style="white-space: nowrap">설명</i>',
    //   titleClass: 'text-center',
    //   dataClass: 'text-right',
    //   callback: 'subStringField',
    // },
    {
      name: 'wines_in_curation',
      title: '<i style="white-space: nowrap">와인 타이틀</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'winesInCurationField',
    },
    {
      name: 'img_top',
      title: '<i style="white-space: nowrap">상단 이미지</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imageField',
    },
    // {
    //   name: 'img_bottom',
    //   title: '<i style="white-space: nowrap">하단 이미지</i>',
    //   titleClass: 'text-center',
    //   dataClass: 'text-right',
    //   callback: 'imgField',
    // },
    {
      name: 'begin_at',
      title: '<i style="white-space: nowrap">시작 시간</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'dateTimeField',
    },
    {
      name: 'expire_at',
      title: '<i style="white-space: nowrap">종료 시간</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'dateTimeField',
    },
    {
      name: 'is_auto_start',
      title: '<p style="white-space: nowrap">자동 실행</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    // {
    //   name: '__slot:actions',
    //   title: '옵션',
    //   titleClass: 'center aligned',
    //   dataClass: 'center aligned',
    // },
  ],
}



// WEBPACK FOOTER //
// ./src/spa/components/board/curation/Config.js